import { Box } from '@qga/roo-ui/components';

import withProps from '@/components/withProps';

const Pill = withProps(({ placement }) => ({
  position: 'absolute',
  bg: 'brand.secondary',
  fontWeight: 'bold',
  fontSize: 'sm',
  px: '3',
  py: '1',
  ...{
    topLeft: {
      borderRadius: '0px 0px 10px 0px',
      top: '0',
      left: '0',
    },
    topRight: {
      borderRadius: '0px 0px 0px 10px',
      top: '0',
      right: '0',
    },
  }[placement],
}))(Box);

export default Pill;
